import script from "./ContactUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactUs.vue?vue&type=script&setup=true&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=b828b45a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b828b45a"]])

export default __exports__